module.exports = __webpack_public_path__ + "img/国家电网.3e1d6054.png";